import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getAuth, onAuthStateChanged, updateEmail, updateProfile } from 'firebase/auth';
import { getFirestore, doc, getDoc, updateDoc } from 'firebase/firestore';
import appFirebase from '../Firebase/Firebase';
import Navbar from '../Components/NavBarAirbnbStyle';
import './myprofile.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Link } from 'react-router-dom';

import userAvatar1 from '../images/1.png';
import userAvatar12 from '../images/1.png';
import userAvatar2 from '../images/2.png';
import userAvatar3 from '../images/3.png';
import userAvatar4 from '../images/4.png';
import userAvatar5 from '../images/5.png';
import userAvatar6 from '../images/6.png';
import userAvatar7 from '../images/7.png';
import userAvatar8 from '../images/8.png';
import NavbarMobileVersion from '../Components/NavBar/NavBarMobileVersion';
import Footer from '../Components/footer';

const avatarsMap = {
  userAvatar1: userAvatar1,
  userAvatar2: userAvatar2,
  userAvatar3: userAvatar3,
  userAvatar4: userAvatar4,
  userAvatar5: userAvatar5,
  userAvatar6: userAvatar6,
  userAvatar7: userAvatar7,
  userAvatar8: userAvatar8,
};

// Inicialización de Firestore y Auth
const db = getFirestore(appFirebase);
const auth = getAuth(appFirebase);


const MyProfile = () => {
  const [user, setUser] = useState(null);
  const [profileForm, setProfileForm] = useState({
    name: '',
    lastName: '',
    email: '',
    role: '',
    coins: 0,
    cedula: '',
    ruc: '',
    avatar: 'userAvatar1',
  });
  const [isEditing, setIsEditing] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedAvatar, setSelectedAvatar] = useState('');
  const [hasChanges, setHasChanges] = useState(false);
  const navigate = useNavigate();
  const avatarsList = Object.keys(avatarsMap);
  const [isBusinessProfile, setIsBusinessProfile] = useState(false);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
      if (currentUser) {
        setUser(currentUser);
        const userDocRef = doc(db, 'usuarios', currentUser.uid);
        const docSnap = await getDoc(userDocRef);

        if (docSnap.exists()) {
          setProfileForm({
            name: docSnap.data().name || '',
            lastName: docSnap.data().lastName || '',
            email: currentUser.email,
            role: docSnap.data().role || '',
            coins: docSnap.data().coins || 0,
            cedula: docSnap.data().cedula || '',
            ruc: docSnap.data().ruc || '',
            avatar: docSnap.data().avatar || 'userAvatar1',
          });
          if (docSnap.data().perfilNegocio) {
            setIsBusinessProfile(true);
          }
        } else {
          console.log("No such document!");
        }
      } else {
        navigate('/login');
      }
    });

    return () => unsubscribe();
  }, [navigate]);

  const handleChange = (e) => {
    const { id, value } = e.target;
    setProfileForm({ ...profileForm, [id]: value });
    setHasChanges(true);
  };

  const handleAvatarSelect = (avatarName) => {
    setSelectedAvatar(avatarName); // Guardamos el nombre del avatar temporalmente
  };

  const handleSaveAvatar = async () => {
    if (!selectedAvatar) return; // Asegurarse de que se ha seleccionado un avatar

    setProfileForm((prev) => ({ ...prev, avatar: selectedAvatar }));
    if (user) {
      const userDocRef = doc(db, 'usuarios', user.uid);
      await updateDoc(userDocRef, { avatar: selectedAvatar }); // Guardar solo el nombre del avatar
      setIsModalOpen(false); // Cerrar el modal después de guardar
    }
  };


  const getAvatarSrc = (avatarName) => avatarsMap[avatarName] || userAvatar12;

  const handleOpenModal = () => {
    setSelectedAvatar(profileForm.avatar); // Cargar el avatar actual en el modal
    setIsModalOpen(true);
  };

  const handleCloseModal = () => setIsModalOpen(false); // Cierra el modal sin guardar cambios


  const handleSubmit = async (e) => {
    e.preventDefault(); // Evitar envío automático
    if (!hasChanges) {

      return;
    }

    try {
      await updateProfile(user, { displayName: profileForm.name });
      await updateEmail(user, profileForm.email);

      const userDocRef = doc(db, 'usuarios', user.uid);
      await updateDoc(userDocRef, {
        name: profileForm.name,
        lastName: profileForm.lastName,
        email: profileForm.email,
        cedula: profileForm.cedula,
        ruc: profileForm.ruc,
      });
      toast.success("Perfil actualizado exitosamente");
      setIsEditing(false);
      setHasChanges(false); // Resetear cambios
    } catch (error) {
      toast.error("Error al actualizar el perfil.");

      console.log('Error al actualizar el perfil: ' + error.message);
    }
  };

  // Función para iniciar la edición
  const handleEdit = () => {
    setIsEditing(true); // Activar modo de edición
  };


  // Función para cancelar los cambios
  const handleCancel = () => {
    setIsEditing(false); // Desactivar modo de edición
    // Opcional: Restaurar los valores originales si se desea
    setHasChanges(false);
  };

  const [isDarkMode, setIsDarkMode] = useState(() => {
    try {
      // Intentamos leer valor guardado en localStorage
      const saved = localStorage.getItem('darkMode');
      if (saved !== null) {
        const parsed = JSON.parse(saved);
        if (typeof parsed === 'boolean') return parsed; // Solo si es booleano válido
      }
    } catch (error) {
      // Si JSON.parse falla o localStorage no está disponible, ignoramos el error
      console.warn('Error leyendo localStorage darkMode:', error);
    }

    // Detectar modo oscuro sistema solo si está disponible window.matchMedia
    const prefersDark = typeof window !== 'undefined' && window.matchMedia
      ? window.matchMedia('(prefers-color-scheme: dark)').matches
      : false;

    // Detectar hora nocturna (7pm a 6am)
    const hour = new Date().getHours();
    const isNight = hour >= 19 || hour < 6;

    // Retorna true o false seguro
    return prefersDark || isNight;
  });

  // Cargar el tema al inicio (localStorage, sistema u hora)
  useEffect(() => {
    const savedTheme = localStorage.getItem('darkMode');
    if (savedTheme !== null) {
      setIsDarkMode(JSON.parse(savedTheme));
    } else {
      // Detecta modo oscuro sistema
      const prefersDark = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;

      // Detecta modo oscuro por hora (7pm - 6am)
      const hour = new Date().getHours();
      const isNight = hour >= 19 || hour < 6;

      setIsDarkMode(prefersDark || isNight);
    }
  }, []);

  // Guardar la preferencia y aplicar clase al body
  useEffect(() => {
    localStorage.setItem('darkMode', JSON.stringify(isDarkMode));
    document.body.classList.toggle('dark-mode', isDarkMode);
  }, [isDarkMode]);

  // Función para cambiar el modo
  const toggleDarkMode = () => setIsDarkMode(!isDarkMode);
  return (
    <div className="profile-container2">
      <Navbar isDarkMode={isDarkMode} toggleDarkMode={toggleDarkMode} />
      <NavbarMobileVersion isDarkMode={isDarkMode} toggleDarkMode={toggleDarkMode} />
      <ToastContainer />

      <div className="profile-header">
        <div className="profile-section">
          <div className="profile-title">
            <h2 className="card-title text-2xl font-bold">Mi Perfil</h2>
            <p className="profile-subtitle">Administra la información de tu cuenta</p>
          </div>

          <div className="profile-form-wrapper">
            <form className="profile-form" onSubmit={handleSubmit}>
              <div className="profile-form-grid">

                {/* Avatar + botón cambiar */}
                <div className="profile-avatar-section">
                  <img
                    src={getAvatarSrc(profileForm.avatar)}
                    alt="Avatar"
                    style={{ width: '100px', cursor: 'pointer' }}
                  />
                  <button className="avatar-change-btn" type="button" onClick={handleOpenModal}>
                    Cambiar Avatar
                  </button>
                </div>

                {/* Modal para selección de avatar */}
                {isModalOpen && (
                  <div className="avatar-modal">
                    <h3>Selecciona tu Avatar</h3>
                    <div className="avatar-selection-list">
                      {avatarsList.map((avatarName) => (
                        <img
                          key={avatarName}
                          src={avatarsMap[avatarName]}
                          alt={avatarName}
                          style={{
                            width: '80px',
                            cursor: 'pointer',
                            margin: '5px',
                            border: selectedAvatar === avatarName ? '2px solid blue' : '2px solid transparent',
                            borderRadius: '10px',
                          }}
                          onClick={() => handleAvatarSelect(avatarName)}
                        />
                      ))}
                    </div>
                    <button className="avatar-save-btn" type="button" onClick={handleSaveAvatar}>Guardar Cambios</button>
                    <button className="avatar-close-btn" type="button" onClick={handleCloseModal}>Cancelar</button>
                  </div>
                )}

                {/* Campos flotantes */}
                <div className="floating-label-wrapper">
                  <input
                    type="text"
                    id="name"
                    value={profileForm.name}
                    onChange={handleChange}
                    disabled={!isEditing}
                    placeholder=""
                  />
                  <label htmlFor="name">Nombre</label>
                </div>

                <div className="floating-label-wrapper">
                  <input
                    type="text"
                    id="lastName"
                    value={profileForm.lastName}
                    onChange={handleChange}
                    disabled={!isEditing}
                  />
                  <label htmlFor="lastName">Apellido</label>
                </div>

                <div className="floating-label-wrapper">
                  <input
                    type="email"
                    id="email"
                    value={profileForm.email}
                    onChange={handleChange}
                    disabled={!isEditing}
                  />
                  <label htmlFor="email">Correo Electrónico</label>
                </div>

                <div className="floating-label-wrapper">
                  <input
                    type="text"
                    id="cedula"
                    value={profileForm.cedula}
                    onChange={handleChange}
                    disabled={!isEditing}
                  />
                  <label htmlFor="cedula">Cédula</label>
                </div>

                <div className="floating-label-wrapper">
                  <input
                    type="text"
                    id="ruc"
                    value={profileForm.ruc}
                    onChange={handleChange}
                    disabled={!isEditing}
                  />
                  <label htmlFor="ruc">RUC</label>
                </div>

                {/* Botones */}
                <div className="profile-buttons">
                  {isEditing ? (
                    <>
                      <button type="submit">Guardar Cambios</button>
                      <button type="button" onClick={handleCancel}>Cancelar</button>
                    </>
                  ) : (
                    <button type="button" onClick={handleEdit}>Editar Perfil</button>
                  )}
                  {
                    isBusinessProfile ? (
                      <Link to="/crear-perfil-negocio">
                        <button className="profile-buttons">Editar Perfil de Negocio</button>
                      </Link>
                    ) : (
                      <Link to="/crear-perfil-negocio">
                        <button className="profile-buttons">Crear Perfil de Negocio</button>
                      </Link>
                    )
                  }
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );

};

export default MyProfile;


